import { render, staticRenderFns } from "./PainterWorkDetails.vue?vue&type=template&id=3a2f2917&scoped=true"
import script from "./PainterWorkDetails.vue?vue&type=script&lang=js"
export * from "./PainterWorkDetails.vue?vue&type=script&lang=js"
import style0 from "./PainterWorkDetails.vue?vue&type=style&index=0&id=3a2f2917&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a2f2917",
  null
  
)

export default component.exports